import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { AiAgentResponse } from '../../../../models/responses/ai-agent-response';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatDivider } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { NgIf } from '@angular/common';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { TelegramService } from '../../../../services/telegram.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AiConfigurationPageEventsService } from '../../../../events/ai-configuration-page-events.service';

@Component({
  selector: 'app-telegram-integration',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatDialogModule,
    MatDivider,
    MatIconModule,
    NgIf,
    MatProgressSpinnerModule
  ],
  templateUrl: './telegram-integration.component.html',
  styleUrl: './telegram-integration.component.scss'
})
export class TelegramIntegrationComponent {
  telegramForm!: FormGroup;
  isLoading: boolean = false;
  isEditing: boolean = false;
  constructor(
    private formBuilder: FormBuilder,
    public dialogRef: MatDialogRef<TelegramIntegrationComponent>,
    private telegramService: TelegramService,
    private snackBar: MatSnackBar,
    private aiConfigurationPageEventsService: AiConfigurationPageEventsService,
    @Inject(MAT_DIALOG_DATA) public data: { aiAgent: AiAgentResponse },
  ) { }

  ngOnInit() {
    this.initForm();
  }

  initForm() {
    const telegramIntegration = this.data.aiAgent.integrations.telegramIntegration;
    if (telegramIntegration) {
      this.isEditing = true;
    }
    this.telegramForm = this.formBuilder.group({
      botKey: [telegramIntegration ? telegramIntegration.botKey : '',Validators.required]
    });
  }

  onSubmit() {
    if (this.telegramForm.valid) {
      const botKey = this.telegramForm.value['botKey']
      this.isLoading = true;
      this.telegramService.upsertBot({ aiAgentId: this.data.aiAgent.id, botKey: botKey }).subscribe({
        next: (data) => {
          this.snackBar.open(`Your telegram bot key was saved`);
          this.isLoading = false;
          this.dialogRef.close();
          this.aiConfigurationPageEventsService.onTelegramIntegrationAddedEvent.emit(data);
        },
        error: error => {
          alert('Error contact support');
          this.isLoading = false;
        }
      })
    }
  }

}
